var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 39 39"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M39 19.5a19.5 19.5 0 1 1-39 0 19.5 19.5 0 0 1 39 0m-22.45-7.086a1.217 1.217 0 0 0-1.925.992v12.188a1.218 1.218 0 0 0 1.926.992l8.53-6.094a1.22 1.22 0 0 0 0-1.984z"
})));
export default SvgPlay;